import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'lm-legal',
    templateUrl: 'legal.component.html'
})

export class LegalComponent { }



// WEBPACK FOOTER //
// ./src/app/features/shared/components/legal/legal.component.ts